<template>
  <div>
    <HeadGetBackBar v-if="showHeadBar"></HeadGetBackBar>
    <!-- <Coze></Coze> -->
    <!-- 启用加载指示器 -->
    <div v-if="loading" class="location-loading">
      <van-loading size="24px" vertical
        >定位中...</van-loading
      >
    </div>
    <div v-else>
      <keep-alive>
        <router-view
          v-if="$route.meta.keepAlive"
          ref="routerView"
          :key="$route.fullPath + cacheKey"
        />
      </keep-alive>
      <router-view
        v-if="!$route.meta.keepAlive"
        ref="routerView"
      ></router-view>
    </div>
    <ScroolTop></ScroolTop>
  </div>
</template>
<script>
import HeadGetBackBar from '@/components/HeadGetBackBar'
import {
  mapMutations,
  mapState,
  mapActions,
  mapGetters
} from 'vuex'
import { movieCityListApi } from '@/api/movie'

// import backLink from '@/components/BackLink/index.vue'
import ScroolTop from '@/components/ScrollTop'
// 路由白名单
const passLocation = [
  '/paymentCashier',
  '/payOrderStatus',
  '/exchange/home'
]
// 不需要等待定位完成的路由
const notWaitLocation = [
  '/tabbar/*',
  '/prodetail',
  '/login'
]

export default {
  components: {
    // backLink
    ScroolTop,
    HeadGetBackBar
  },
  data() {
    return {
      cacheKey: 0,
      loading: true
    }
  },
  computed: {
    ...mapGetters({ currentLocation: 'location' }),
    showHeadBar() {
      const showHeadBar = this.$route.meta.showHeadBar
      return (
        showHeadBar === undefined || showHeadBar === true
      )
    },
    showScrollTop() {
      const showScrollTop = this.$route.meta.showScrollTop
      return (
        showScrollTop === undefined ||
        showScrollTop === true
      )
    }
  },
  methods: {
    ...mapActions('location', ['getLocation']),
    ...mapMutations('location', ['setMoiveInfo']),
    // 电影路由处理
    async pathMoviehandle() {
      const { city } = this.currentLocation
      if (!city) return
      // 根据城市名称获取电影定位信息
      const res = await movieCityListApi({
        keyword: city
      }).catch(() => {
        this.loading = false
      })
      if (
        res.data.data.status &&
        res.data.data.cityList.length > 0
      ) {
        this.setMoiveInfo(res.data.data.cityList[0])
      }
      this.loading = false
    },
    cleanCacheView() {
      // 增加 cacheKey 来强制组件重新渲染
      this.cacheKey++
    },
    async setLocation() {
      this.loading = true
      if (passLocation.includes(this.$route.path)) {
        this.loading = false
        return
      }
      try {
        const isPassWait = notWaitLocation.some(item => {
          if (item.includes('/*')) {
            return this.$route.path.includes(
              item.replace('/*', '')
            )
          } else if (item === this.$route.path) {
            return true
          }
        })

        if (isPassWait) {
          // 在后台执行定位，不阻塞页面渲染
          this.getLocation().catch(err => {
            console.error('后台定位失败:', err)
          })
          this.loading = false
          return
        }

        // 等待定位完成或超时
        await Promise.race([
          this.getLocation(),
          new Promise(resolve =>
            setTimeout(() => {
              // 超时时使用默认位置，让页面正常显示
              console.warn('定位超时，使用默认位置')
              this.$store.state.location.locationInfo = {
                lat: 23.12463,
                lng: 113.36199,
                city: '广州市',
                province: '广东省'
              }
              resolve()
            }, 10000)
          )
        ]).finally(() => {
          if (this.$route.path.includes('/movie')) {
            this.pathMoviehandle()
            return
          }
          this.loading = false
        })

        // 电影路由处理
      } catch (err) {
        console.error('定位过程出错:', err)
        // 发生错误时也确保页面能正常显示
        this.loading = false
      }
    }
  },
  async created() {
    this.$root.$on('cleanCacheView', () => {
      this.cleanCacheView()
    })
    this.setLocation()
  },
  beforeDestroy() {
    // this.$root.$off('cleanCacheView')
  }
}
</script>
<style lang="scss" scoped>
.location-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
}
</style>
